// Pages for Convenor staff (PLATFORM_ADMINS; not sitemap screens).
import { PAGES } from "@convenor/shared";
import { extra, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra(PAGES.staffEmails, page(() => import("./pages/EmailLogPage"), "EmailLogPage"), { allowNoOrg: true }),
  extra(PAGES.staffTrials, page(() => import("./pages/TrialsPage"), "TrialsPage"), { allowNoOrg: true }),
  extra(PAGES.staffOrganisationsNew, page(() => import("./pages/NewOrganisationPage"), "NewOrganisationPage"), { allowNoOrg: true }),
];
